import React from 'react';
import { SelectField, useRecordContext } from 'react-admin';

import { get } from 'lodash';

import Answer from '../Answer';

import booleanChoices from '../../../../constants/booleanChoices';
import languages, { Languages } from '../../../../constants/languages';
import conflictFields from '../../../../constants/conflictFields';
import applyChoices from '../../applyChoices';
import { BooleanQuestionParameters } from '../../questionParameters';

const CONTENT = {
  [languages.SV]: 'Har företaget en verklig huvudman?',
  [languages.EN]: 'Do you have a beneficial owner?',
  [languages.DE]: 'Hat das Unternehmen eine/n wirtschaftlich Berechtigte/n?',
};

const ValueField = ({ language, extraParameters }: {
  language?: Languages;
  extraParameters?: BooleanQuestionParameters;
}) => {
  const record = useRecordContext();

  const value = get(record, 'value');
  const sx = get(record, 'sx', {});

  if (!language) return null;

  const choices = applyChoices(
    booleanChoices[language],
    extraParameters?.options,
    extraParameters?.choiceLabels,
  );

  return <SelectField record={{ value }} sx={sx} choices={choices} source="value" emptyText="-" fontWeight="bold" />;
};

const BeneficialOwner = ({ extraParameters }: {
  extraParameters?: BooleanQuestionParameters;
}) => {
  const record = useRecordContext();

  const language = record?.language as Languages;

  return (
    <Answer
      label={extraParameters?.label ?? CONTENT[language]}
      datapoint={conflictFields.BENEFICIAL_OWNER}
      identificationInfo={undefined}
      source="beneficialOwner"
    >
      <ValueField language={language} extraParameters={extraParameters} />
    </Answer>
  );
};

BeneficialOwner.ValueField = ValueField;

export default BeneficialOwner;
